import {SODeleteMessage} from '../../core/message/so-delete-message';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteMessage extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteMessage;
}